import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["package", "maxMembersCount", "copyMembershipsCheckbox"];

  // packages maps a package key to its member limit (Group::PACKAGE_MEMBER_LIMITS).
  static values = { packages: Object, membershipsCount: Number };

  changePackage(event) {
    this.setMaxMembers(event);
    this.toggleCheckbox();
  }

  changeMaxMembersCount(event) {
    if (this.membershipsCountValue) {
      this.toggleCheckbox();
    }
  }

  setMaxMembers(event) {
    if (!this.hasMaxMembersCountTarget) return;

    this.maxMembersCountTarget.value = this.packagesValue[event.target.value];

    // Manually dispatch change event to trigger other controllers
    this.maxMembersCountTarget.dispatchEvent(
      new Event("change", { bubbles: true })
    );
  }

  toggleCheckbox() {
    if (!this.hasCopyMembershipsCheckboxTarget) return;

    const maxMembers = Number(this.maxMembersCountTarget.value);
    if (maxMembers > 0 && this.membershipsCountValue > maxMembers) {
      this.copyMembershipsCheckboxTarget.disabled = true;
    } else {
      this.copyMembershipsCheckboxTarget.disabled = false;
    }
  }
}
